const actionScope = '[SSO Mapping Rules Banner]';

export class LoadBannerVisibility {
  static readonly type = `${actionScope} Load Banner Visibility`;
}

export class AcknowledgeBanner {
  static readonly type = `${actionScope} Acknowledge Banner`;
}
